import { Button, Checkbox, Modal } from "antd";
import { WarningFilled } from "@ant-design/icons";
import { useState } from "react";
const ModalTitle = (
  <>
    <WarningFilled style={{ marginRight: "8px", color: "#f57c00" }} />
    Attenzione
  </>
);

const PenaltiesPositioningInfoModal = (props: { onOk: any; open: any }) => {
  const [isConfirmChecked, setIsConfirmChecked] = useState(false);
  const [noShow, setNoShow] = useState(true);
  const handleConfirmChange = (e: any) => {
    setIsConfirmChecked(e.target.checked);
  };

  const handleNoShowChange = (e: any) => {
    setNoShow(e.target.checked);
  };

  return (
    <Modal
      title={ModalTitle}
      open={props.open}
      okButtonProps={{ disabled: !isConfirmChecked }}
      closable={false}
      footer={[
        <Button
          type="primary"
          disabled={!isConfirmChecked}
          onClick={() => props.onOk(noShow)}
        >
          OK
        </Button>,
      ]}
    >
      <p>
        Si comunica che, a decorrere dal 12 ottobre 2025, in caso di ritardo al
        posizionamento richiesto per l'esecuzione del servizio di trasporto,
        verranno applicate le misure previste dagli artt.6.11 e 18, dei nostri
        Termini e Condizioni Generali o, per i trasportatori che avranno
        sottoscritto il contratto quadro, dalle corrispondenti disposizioni
        contenute in tale accordo. Si precisa, inoltre, che in caso di
        difformità rilevate è previsto il procedimento di contraddittorio
        finalizzato a confermare o meno l’applicazione delle penali al Vettore.
        Il Vettore espressamente accetta che, in caso di mancato riscontro nel
        previsto form a seguito di comunicazione anticipata di applicazione
        della penale di riferimento da parte di sennder e nelle tempistiche
        previste, ciò sarà da considerarsi come tacita accettazione alla
        relativa applicazione. Per qualsiasi chiarimento o necessità di
        approfondimento, vi invitiamo a contattare il nostro servizio di
        supporto all’indirizzo email indicato nella sezione contatti.
      </p>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Checkbox onChange={handleConfirmChange}>
          Conferma presa visione
        </Checkbox>
        <Checkbox onChange={handleNoShowChange} checked={noShow}>
          Non mostrare più
        </Checkbox>
      </div>
    </Modal>
  );
};

export default PenaltiesPositioningInfoModal;
